



















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ia_agent } from "@/shared/classes/ia_agents_store";

@Component({
  components: {},
})
export default class ia_agent_editor extends Vue {
  @Prop({ default: null }) public value!: ia_agent | null;

  public model: ia_agent = {
    id: "",
    name: "",
    description: "",
    category: "",
    icon: "🤖",
    tags: [],
    systemPrompt: "",
    empezar: "",
    isPublic: false,
    createdAt: 0,
    updatedAt: 0,
  };

  //public levels: string[] = ["Bajo", "Medio", "Alto"];
  public tagsProxy: string[] = [];

  get isEditMode(): boolean {
    return !!(this.value && this.value.id);
  }

  get isValid(): boolean {
    return (
      this.model.name.trim().length > 0 &&
      this.model.systemPrompt.trim().length > 0
    );
  }

  public mounted(): void {
    this.syncFromProp();
  }

  @Watch("value")
  onValueChanged(): void {
    this.syncFromProp();
  }

  private syncFromProp(): void {
    if (this.value && this.value.id) {
      this.model = JSON.parse(JSON.stringify(this.value));
    } else {
      this.model = {
        id: "",
        name: "",
        description: "",
        category: "",
        icon: "🤖",
        empezar: "",
        tags: [],
        systemPrompt: "",
        isPublic: false,
        createdAt: 0,
        updatedAt: 0,
      };
    }
    this.tagsProxy = this.model.tags ? this.model.tags.slice(0) : [];
  }

  public save(): void {
    this.model.tags = this.tagsProxy.filter(function(t) {
      return t && t.trim().length > 0;
    });
    this.$emit("save", this.model);
  }
}
